import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { opcoesRescisao } from '../../ContratoUtils';

const RescisaoContratoVisualizacao = ({ rescisao }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <TextLabel
          id="rescisao.data"
          label="Data da rescisão"
          value={rescisao?.data && moment(rescisao.data).format('DD/MM/YYYY')}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel id="rescisao.motivo" label="Motivo" value={rescisao.motivo ? opcoesRescisao[rescisao.motivo] : ''} />
      </Grid>
      <Grid item xs={12}>
        <TextLabel id="rescisao.comentario" label="Comentarios" value={rescisao?.comentario} />
      </Grid>
    </Grid>
  );
};

export default RescisaoContratoVisualizacao;
